import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { convertNumber, getUnixTimestamp } from 'helpers/utils';
import { useDispatch } from 'react-redux';
import { RentExit } from 'store/transferAct/actions';

import { InfoCard, InfoCardBlock, InfoCardLink, InfoCardComment } from 'components/InfoCard';

const InfoCardsExitSection = ({ rent, stock, showEmpty }) => {
  const [cardPending, setCardPending] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    if (rent) {
      setCardPending(false);
    } else {
      setCardPending(true);
    }
  }, [rent]);

  const deleteFine = (fronEndID) => {
    dispatch(RentExit.updateRent({ fine: rent.fine.filter((elem) => elem.fronEndID != fronEndID) }));
  };

  const deleteDiscount = (fronEndID) => {
    dispatch(RentExit.updateRent({ discount: rent.discount.filter((elem) => elem.fronEndID != fronEndID) }));
  };

  return (
    <div className="rent-section">
      <InfoCard title="Клиент" pending={cardPending} showCard={!!showEmpty} showContent={!!rent?.client}>
        <InfoCardBlock title="ФИО" text={rent?.client?.FIO} />

        <InfoCardBlock title="Номер" text={convertNumber(rent?.client?.PhMain)} />
        <InfoCardLink
          title="Перейти в профиль"
          link={{
            url: `/client/${rent?.client?.id}`,
            params: {
              redirectFromRent: `/rent${rent.actID1C ? `/${rent.actID1C}` : ''}`,
            },
          }}
        />
      </InfoCard>
      <InfoCard
        title="Общее"
        pending={cardPending}
        showCard={!!showEmpty}
        showContent={!!stock || !!rent?.agr || !!rent?.endDateTime}
      >
        {rent?.agr && <InfoCardBlock title="ФОП" text={rent.agr.organization.orgName} />}

        {stock && <InfoCardBlock title="Склад" text={stock?.stockName} />}

        {rent && rent.endDateTime > 0 && (
          <InfoCardBlock
            title="Срок"
            text={`${Math.round((rent.endDateTime - (rent.startDateTime || getUnixTimestamp())) / 86400)} сут.`}
          />
        )}
      </InfoCard>
      <InfoCard title="Комментарий" showCard={!!showEmpty} showContent={!!rent?.comment} pending={cardPending}>
        {rent?.comment}
      </InfoCard>

      {rent?.fine.map((elem) => {
        return (
          <InfoCard
            title="Штраф"
            key={elem.fronEndID}
            pending={cardPending}
            showCard={!!showEmpty}
            showContent
            icon={elem.conduct && <div className="c1-button">1C</div>}
          >
            <div className="wrap-btn-icon-delete">
              <div className="delete-icon" onClick={() => deleteFine(elem.fronEndID)}>
                <div className="icon-trash-svg" />
              </div>
            </div>

            <InfoCardBlock title="Статья" text={elem.accrualSubType?.name} />

            <InfoCardBlock title="Сумма" text={`${elem.sum} грн.`} />

            <InfoCardComment text={elem.comment || ''} />
          </InfoCard>
        );
      })}

      {rent?.discount.map((elem) => {
        return (
          <InfoCard
            key={elem.fronEndID}
            title="Скидка"
            pending={cardPending}
            showCard={!!showEmpty}
            showContent
            icon={elem.conduct && <div className="c1-button">1C</div>}
          >
            <div className="wrap-btn-icon-delete">
              <div className="delete-icon" onClick={() => deleteDiscount(elem.fronEndID)}>
                <div className="icon-trash-svg" />
              </div>
            </div>

            <InfoCardBlock title="Статья" text={elem.accrualSubType?.name} />

            <InfoCardBlock title="Сумма" text={`${elem.sum} грн.`} />

            <InfoCardComment text={elem.comment || ''} />
          </InfoCard>
        );
      })}
    </div>
  );
};

InfoCardsExitSection.propTypes = {
  rent: PropTypes.any,
  stock: PropTypes.any,
  showEmpty: PropTypes.bool,
};

InfoCardsExitSection.defaultProps = {
  rent: null,
  stock: null,
  showEmpty: true,
};

export { InfoCardsExitSection };
